import type { Settings } from './types'

// export const CINEMETA_URL = 'https://v3-cinemeta.strem.io'
export const OPENSUBTITLES_URL = 'https://opensubtitles-v3.strem.io'
export const PAIRING_API_URL = (import.meta.env.VITE_PAIRING_API_URL || 'https://pair.vela.aoo.cz').replace(/\/+$/, '')
// Injected from package.json at build time; the dev server defines it too.
export const APP_VERSION = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0-dev'
/**
 * Where this installation is published. An installed webOS app runs from
 * file://, which has no useful origin, so it falls back to the build-time value
 * — but a self-hosted web deployment must show its own address rather than the
 * one this project happens to publish to.
 */
export function publicOrigin() {
  if (typeof location !== 'undefined' && (location.protocol === 'https:' || location.protocol === 'http:') && location.host) {
    return location.origin
  }
  return (import.meta.env.VITE_PUBLIC_URL || 'https://vela.aoo.cz').replace(/\/+$/, '')
}

/** The phone-facing setup page for this installation. */
export const setupUrl = () => `${publicOrigin()}/setup/`
// The local endpoint is protocol-compatible with Cinemeta and keeps a
// disk-backed stale-while-revalidate cache on the streaming VPS.
export const CINEMETA_URL = 'https://stremio-backend.aoo.cz/cinemeta'
export const DEFAULT_SETTINGS: Settings = {
  serverUrl: 'https://stremio-backend.aoo.cz',
  torrentioUrl: 'https://torrentio.strem.fun',
  torrentioEnabled: true,
  autoplayNext: true,
  preferHls: true,
  subtitlesEnabled: true,
  subtitleLanguage: 'eng',
  subtitleSize: 'medium',
  subtitlesUrl: OPENSUBTITLES_URL,
  hdrMode: 'auto',
  addonsConfigured: true,
  addons: [
    {
      id: 'torrentio',
      name: 'Torrentio',
      url: 'https://torrentio.strem.fun',
      enabled: true,
      priority: 0,
      resources: ['catalog', 'meta', 'stream'],
    },
    {
      id: 'opensubtitles',
      name: 'OpenSubtitles',
      url: OPENSUBTITLES_URL,
      enabled: true,
      priority: 1,
      resources: ['subtitles'],
    },
  ],
  subtitleDelay: 0,
  subtitlePosition: 'bottom',
  subtitleBackground: 'shadow',
  subtitleSdh: 'include',
  subtitleForced: 'prefer',
  subtitleEncoding: 'auto',
  preferredAudioLanguage: 'eng',
  restorePlayback: true,
  oledProtection: true,
}

export const STORAGE = {
  settings: 'vela.settings.v1',
  library: 'vela.library.v1',
  progress: 'vela.progress.v1',
  watched: 'vela.watched.v1',
  network: 'vela.network.v1',
  setup: 'vela.setup.v1',
  searches: 'vela.searches.v1',
  tvRemote: 'vela.remote.tv.v1',
  controllerRemotes: 'vela.remote.controllers.v1',
  hdrCapabilities: 'vela.hdr.capabilities.v1',
  compatibility: 'vela.compatibility.v1',
  playbackSession: 'vela.playback.session.v1',
  householdProfiles: 'vela.household.profiles.v1',
  inputMode: 'vela.input.mode.v1',
  focusMemory: 'vela.focus.v1',
  lastSection: 'vela.section.v1',
  phoneSyncCarriers: 'vela.sync.phone-carriers.v1',
  config: 'vela.config.v1',
}
